import EngineModule from '../../../EngineModule';
import { NS as StandingObjectsPositioningDynamicsSetsNS } from '../../../components/customers/standing/StandingObjectsPositioningDynamicsSets/StandingObjectsPositioningDynamicsSets';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-objectsPositioningDynamicsSets',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS' , 'sam1_12345'],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingObjectsPositioningDynamicsSetsNS.Configuration {
		return {

		};
	},
	async initialize() {
	}
});
